const state = {
  patientInfo: {}
}
const mutations = {
  SETINFO(state, info) {
    state.patientInfo = info;
  }
}
const actions = {
  // 设置患者信息
  setInfo({ commit }, patInfo) {
    commit('SETINFO', patInfo)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/patient.js